export default __webpack_public_path__ + "static/media/back-office-solutions.c34dac77.svg";